'use client';

import { Link, Stack, SxProps } from '@mui/material';
import { TNavbarPage } from '../../types/admin';

export interface NavItemsProps {
  onClick: (page: TNavbarPage) => void;
  containerStyles?: SxProps;
  itemStyles?: SxProps;
  navbarPages: TNavbarPage[];
  activeKey?: string;
  isAdminPreview?: boolean;
  direction?: 'ltr' | 'rtl';
}

export function NavItems({
  onClick,
  containerStyles = {},
  itemStyles = {},
  navbarPages,
  activeKey,
  isAdminPreview = false,
  direction = 'ltr',
}: NavItemsProps) {
  return (
    <Stack direction="row" spacing={4} alignItems="center" sx={containerStyles} dir={direction}>
      {navbarPages.map((p) => {
        const isActive = activeKey === (isAdminPreview ? p.previewSectionsKey || p.key : p.key);
        return (
          <Link
            key={p.key}
            component="button"
            onClick={() => onClick(p)}
            data-treedistestid={`nav-item-${p.key.toLowerCase()}`}
            sx={{
              textDecoration: 'none',
              borderBottom: `2px solid transparent`,
              color: 'grey.800',
              fontSize: '16px',
              ...(isActive && {
                color: '#0494FE',
                borderColor: '#0494FE',
              }),
              '&:hover': {
                textDecoration: 'none',
                color: '#0494FE',
              },
              ...itemStyles,
            }}
          >
            {p.label}
          </Link>
        );
      })}
    </Stack>
  );
}
